import React from 'react';
import { Brain, Heart, Lightbulb, Users, Compass, Rocket } from 'lucide-react';
import { Category } from '../types';

interface CategorySelectionProps {
  categories: Category[];
  onSelectCategory: (category: Category) => void;
}

const CategorySelection: React.FC<CategorySelectionProps> = ({ categories, onSelectCategory }) => {
  const categoryIcons = {
    mental_resilience: Brain,
    emotional_intelligence: Heart,
    productivity: Lightbulb,
    relationship_social: Users,
    purpose_meaning: Compass,
    personal_growth: Rocket,
  };

  return (
    <div className="bg-gradient-to-br from-sky-100 to-indigo-100 rounded-xl shadow-lg p-6 w-full max-h-full overflow-y-auto">
      <div className="flex items-center justify-between mb-8">
        <h2 className="text-2xl font-bold text-indigo-900">Choose Your Path</h2>
        <div className="px-4 py-2 bg-white rounded-full shadow-md text-sm font-medium text-indigo-600">
          Growth Journey
        </div>
      </div>

      <div className="grid grid-cols-2 gap-4">
        {categories.map((category) => {
          const Icon = categoryIcons[category.type];
          
          return (
            <button
              key={category.id}
              onClick={() => onSelectCategory(category)}
              className={`
                relative group bg-white rounded-xl p-4
                transform transition-all duration-300 hover:scale-[1.02]
                hover:shadow-lg border border-gray-100
                hover:border-${category.color}-200
              `}
            >
              <div className="flex items-center mb-3">
                <div className={`
                  w-10 h-10 rounded-xl
                  bg-${category.color}-50 flex items-center justify-center
                  group-hover:bg-${category.color}-100 transition-colors mr-3
                `}>
                  <Icon className={`w-5 h-5 text-${category.color}-500`} />
                </div>
                <h3 className="text-base font-semibold text-gray-800">{category.title}</h3>
              </div>

              <div className="flex items-center justify-between text-sm">
                <div className={`px-3 py-1.5 rounded-full font-medium bg-${category.color}-50 text-${category.color}-600`}>
                  {category.lessons.length} lessons
                </div>
                <div className="text-gray-500">
                  {category.lessons.filter(l => l.completed).length} completed
                </div>
              </div>
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default CategorySelection;